import * as types from '../mutation-types'

import Vapi from 'vuex-rest-api'
import { merge, cloneDeep } from 'lodash'
import Vue from 'vue'

const initialUserState = {
  all: [],
  current: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phone: '',
    cellPhone: '',
    position: '',
    cardId: '',
    roles: [],
    orgs: [],
    active: true,
    photo: null
  }
}

const module = new Vapi({
  baseURL: Vue.$backendBaseURL,
  state: cloneDeep(initialUserState)
})
.get({
  action: 'listUsers',
  property: 'all',
  path: ({ orgId }) => `/orgs/${orgId}/users`
})
.get({
  action: 'getUser',
  property: 'current',
  path: ({ orgId, id }) => `/orgs/${orgId}/users/${id}`
})
.post({
  action: 'createUser',
  property: 'current',
  path: ({ orgId }) => `/orgs/${orgId}/users`
})
.put({
  action: 'updateUser',
  property: 'current',
  path: ({ orgId, id }) => `/orgs/${orgId}/users/${id}`,
  onError: (state, error) => {}
})
.getStore()

const state = {
}

const getters = {
}

const actions = {
  transformUserRoles ({ commit, state, rootState }) {
    const roles = state.current.roles.map(item => {
      if (item.organizationId === rootState.authentication.currentOrgId) {
        return item.roleId
      }
    })
    commit(types.SET_USER_ROLES, { roles })
  },
  reset ({ commit, rootState }) {
    commit(types.RESET_USER_STATE)
  }
}

const mutations = {
  [types.RESET_USER_STATE] (state) {
    state.all = []
    state.current = cloneDeep(initialUserState)
    state.pending = {
      all: false,
      current: false
    }
    state.error = {
      all: null,
      current: null
    }
  },

  [types.RESET_USER_CURRENT] (state) {
    state.current = null
    state.pending.current = false
    state.error.current = null
  },

  [types.SET_USER_ROLES] (state, { roles }) {
    state.current.roles = roles
  },

  [types.TMP] (state) {
    delete state.current.photo
  }
}

export default merge(module, {
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/user.js